export const smallBreakpoint = 576;
export const mediumBreakpoint = 768;
export const largeBreakpoint = 992;
export const extraLargeBreakpoint = 1200;
export const extraExtraLargeBreakpoint = 1400;
